import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ContentLoadingProgressComponent } from './content-loading-progress.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        NgxSkeletonLoaderModule,
    ],
    declarations: [ContentLoadingProgressComponent],
    providers: [],
    exports: [ContentLoadingProgressComponent],
})
export class ContentLoadingProgressModule {}
